import React from 'react';
import PropTypes from 'prop-types';
import ReactECharts from 'echarts-for-react';
import { Spin } from 'antd';

const ConnectionChart = ({ timestamps, isLoading }) => {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin />
      </div>
    );
  }

  // Convert from seconds to milliseconds
  const timestampsInMs = timestamps.map((t) => t * 1000);

  // Add `now` to extend the timeline
  const now = Date.now();
  const lastTimestamp = timestampsInMs[timestampsInMs.length - 1];

  const baseData = timestampsInMs.map((ts) => ({ value: [ts, 0.2] }));
  const barData = timestampsInMs.map((ts) => ({ value: [ts, 0.8] }));

  if (now > lastTimestamp) {
    // Add empty bar at "now" to extend the chart without drawing a visible bar
    barData.push({ value: [now, 0] });
  }

  const start = new Date(timestampsInMs[0]);
  const end = new Date(timestampsInMs[timestampsInMs.length - 1]);
  const multiDay = (end - start) > 24 * 60 * 60 * 1000; // More than 24 hours

  const splitNumber = 5;
  const margin = 0.1; // 10% margin around target

  const minValue = timestampsInMs[0];
  const maxValue = timestampsInMs[timestampsInMs.length - 1];

  const range = maxValue - minValue;
  const interval = range / (splitNumber - 1);

  const minInterval = interval * (1 - margin);
  const maxInterval = interval * (1 + margin);

  const option = {
    grid: {
      top: 0,
      right: 5,
      bottom: 20,
      left: 5,
      // containLabel: true,
    },
    xAxis: {
      type: 'time',
      min: minValue,
      max: maxValue,
      minInterval,
      maxInterval,
      splitNumber,
      axisLine: {
        show: true,
        lineStyle: {
          color: '#D9E0E4',
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: (value) => {
          const date = new Date(Number(value));

          if (multiDay) {
            // Show both date and time
            return date.toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            });
          }

          // Only show time
          return date.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          });
        },
      },
    },
    yAxis: {
      type: 'value',
      show: false,
      min: 0,
      max: 1,
    },
    series: [
      {
        type: 'bar',
        stack: 'offset',
        data: baseData,
        itemStyle: {
          color: 'transparent',
        },
        emphasis: {
          disabled: true,
        },
      },
      {
        type: 'bar',
        stack: 'offset',
        data: barData,
        barCategoryGap: '60%',
        itemStyle: {
          color: '#D9E0E4',
          borderRadius: [4, 4, 4, 4],
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{
        width: '100%',
        height: '65px',
      }}
    />
  );
};

ConnectionChart.propTypes = {
  timestamps: PropTypes.array,
  isLoading: PropTypes.bool,
};

ConnectionChart.defaultProps = {
  timestamps: [],
  isLoading: false,
};

export default ConnectionChart;
